import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'

import { domainCountry } from '@/src/constants/domain'
import { FlightOffer } from '@/src/types/flightOffer'
import { transformOfferDetailResponse } from '@/src/utils/offerDetailUtils'
import { getCurrentLocale } from '@/src/utils/rtkQuery/getCurrentLocale'

const baseQuery = fetchBaseQuery({
    prepareHeaders: headers => {
        const locale = getCurrentLocale()
        headers.set('Accept', 'application/json')
        headers.set('Content-Type', 'application/json')
        headers.set('X-CT-SOURCETYPE', 'web')
        headers.set('preferred-language', locale)
        return headers
    }
})

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 })

export const offersApi = createApi({
    reducerPath: 'offersApi',
    baseQuery: baseQueryWithRetry,
    tagTypes: ['Offers'],
    endpoints: builder => ({
        getOfferDetail: builder.query<FlightOffer, { offerSlug: string; locale: string }>({
            query: ({ offerSlug }) => ({
                url: `/node/flight/offers/${offerSlug}?domain=${domainCountry}`,
                method: 'GET'
            }),
            transformResponse: (response: any, _meta, arg) => {
                return transformOfferDetailResponse(response, arg.offerSlug, arg.locale)
            },
            providesTags: ['Offers']
        })
    })
})

export const { useGetOfferDetailQuery } = offersApi
export default offersApi
